import { ChevronRight } from 'lucide-react';
import type { ReactNode } from 'react';
import { useAuth } from '../auth/AuthProvider';

/** Logo: imagen de la marca del tenant o el cuadro con la inicial (estilo Suel2 Nómina). */
export function Logo({ nombre, logoUrl, grande }: { nombre: string; logoUrl?: string | null | undefined; grande?: boolean }) {
  if (logoUrl) return <img src={logoUrl} alt="" className={`w-logo${grande ? ' w-logo--grande' : ''}`} />;
  return (
    <span className={`w-logo-inicial${grande ? ' w-logo-inicial--grande' : ''}`} aria-hidden="true">
      {nombre.trim().charAt(0).toUpperCase() || 'T'}
    </span>
  );
}

const FUNCIONES = [
  'Registro de tarjas en terreno, con o sin conexión',
  'Validación de jornadas y reparto de cuadrillas',
  'Tarifarios por labor, cuartel y temporada',
  'Cierre de periodo y envío a la nómina de Suel2',
];

/**
 * Pantalla de acceso partida (login, registro, invitación, restablecer), igual a la de Suel2 Nómina:
 * panel de marca con degradado a la izquierda (≥ 1024 px) y formulario a la derecha.
 */
export function PantallaAcceso({ children, pie }: { children: ReactNode; pie?: ReactNode }) {
  const { marca } = useAuth();
  const producto = marca.nombre_producto ?? 'Tarja';
  return (
    <main className="w-login">
      <section className="w-login__panel" aria-hidden="true">
        <div className="w-login__logo">
          <Logo nombre={producto} logoUrl={marca.logo_url} grande />
          <span>{producto}</span>
        </div>
        <div>
          <p className="w-login__titular">
            Control de
            <br />
            <span>Tarjas</span>
            <br />
            Agrícolas
          </p>
          <p className="w-login__bajada">Registra la producción en terreno y lleva los tratos a la liquidación de sueldo, sin planillas paralelas.</p>
          <ul className="w-login__funciones">
            {FUNCIONES.map((f) => (
              <li key={f}>
                <ChevronRight size={16} />
                {f}
              </li>
            ))}
          </ul>
        </div>
        <p className="w-login__copy">© {new Date().getFullYear()} Suel2 · Todos los derechos reservados</p>
      </section>

      <div className="w-login__lado">
        <div className="w-login__caja">
          <div className="w-login__marca">
            <Logo nombre={producto} logoUrl={marca.logo_url} />
            <span>{producto}</span>
          </div>
          {children}
          {pie}
          <p className="w-login__nota">Sistema de uso interno · Suel2 Tarja</p>
        </div>
      </div>
    </main>
  );
}
